
import StoryblokComponent from '~/components/Storyblok/Component'
import breakpointMixin from '~/mixins/breakpoints'

export default {
  components: { StoryblokComponent },
  mixins: [breakpointMixin],
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      element: null,
      isSVG: false,
      imgSrc: null,
      imgAlt: '',
    }
  },
  computed: {
    containerStyles() {
      const styles = {}

      return styles
    },
    captionStyles() {
      const styles = {}

      return styles
    },
    imgStyles() {
      const styles = {}

      return styles
    },
    imageSource() {
      const isMobile = this.getBreakpointValue(this.blok.setMobileBreakpoint)

      const desktopSrc = this.blok.src?.filename
      const mobileSrc = this.blok.mobileSrc?.filename || desktopSrc

      if (isMobile === 'true') {
        return mobileSrc
      } else {
        return desktopSrc
      }
    },
  },

  mounted() {
    this.$nextTick(() => {
      // this.setImgAttr()
      // this.handleStoryblokAsset()
    })
  },
}
